@if (avoinna()) {
  <div class="search-overlay" (mousedown)="taustaaKlikattu($event)">
    <div class="search-panel" role="dialog" aria-modal="true" cdkTrapFocus [attr.aria-label]="'tuotteet.haku.modal-otsikko' | translate | async">
      <button class="search-close" type="button" (click)="sulje()" [attr.aria-label]="'tuotteet.haku.sulje' | translate | async">
        <mat-icon>close</mat-icon>
      </button>

      <div class="search-content">
        <div class="hakupalkki">
          <mat-icon>search</mat-icon>
          <input type="text" #hakukentta [formField]="hakuteksti" [placeholder]="'tuotteet.haku.hakukentan-placeholder' | translate | async" [attr.aria-label]="'tuotteet.haku.hakukentan-placeholder' | translate | async" autocomplete="off" />
          @if (hakusana()) {
            <button type="button" class="hakupalkki-tyhjenna" (click)="tyhjennaHaku()" [attr.aria-label]="'tuotteet.haku.tyhjenna' | translate | async">
              <mat-icon>close</mat-icon>
            </button>
          }
        </div>

        <div class="results">
          @if (haetaan()) {
            <div class="hint">{{ 'tuotteet.haku.haetaan' | translate | async }}</div>
          } @else if (tulokset().length === 0) {
            @if (hakusana()) {
              <div class="hint">
                {{ 'tuotteet.haku.ei-osumia-haulla' | translate: { hakusana: hakusana() } | async }}
                <div>{{ 'tuotteet.haku.ei-osumia-vihje' | translate | async }}</div>
              </div>
            } @else {
              <div class="hint">{{ 'tuotteet.haku.hakuohje' | translate | async }}</div>
            }
          } @else {
            <table class="tulokset-taulukko">
              <thead>
                <tr>
                  <th>{{ 'tuotteet.nimi' | translate | async }}</th>
                  <th>{{ 'tuotteet.yksikko' | translate | async }}</th>
                  <th class="r">{{ 'tuotteet.hinta-veroton' | translate | async }}</th>
                  <th class="r">{{ 'tuotteet.hinta-verollinen' | translate | async }}</th>
                  <th class="r">{{ 'tuotteet.alv' | translate | async }}</th>
                </tr>
              </thead>
              <tbody>
                @for (tuote of tulokset(); track tuote.$key) {
                  <tr class="tulos-rivi" tabindex="0" (click)="avaaTuote(tuote)" (keydown.enter)="avaaTuote(tuote)" (keydown.space)="$event.preventDefault(); avaaTuote(tuote)">
                    <td>
                      <div class="tulos-otsikko">{{ tuote.nimi }}</div>
                      @if (tuote.kuvaus) {
                        <div class="tulos-lisatiedot">{{ tuote.kuvaus }}</div>
                      }
                    </td>
                    <td>{{ tuote.yksikko || '–' }}</td>
                    <td class="r">{{ tuote.hinta | lmoney: tuote.valuutta | async }}</td>
                    <td class="r verollinen">
                      @if (tuote.hintaVerollinen !== null) {
                        {{ tuote.hintaVerollinen | lmoney: tuote.valuutta | async }}
                      } @else {
                        –
                      }
                    </td>
                    <td class="r">
                      @if (tuote.alvProsentti !== null) {
                        {{ tuote.alvProsentti | ldecimal: 2 | async }} %
                      } @else {
                        –
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
            <mat-paginator class="haku-paginator" [length]="kokonaismaara()" [pageIndex]="sivu" [pageSize]="sivunKoko" [pageSizeOptions]="sivukoot" showFirstLastButtons (page)="sivuMuuttui($event)"></mat-paginator>
          }
        </div>
      </div>
    </div>
  </div>
}
